var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center" },
        [
          _c("h5", { staticClass: "mr-3" }, [
            _vm._v("¿Qué son los observadores?")
          ]),
          _c(
            "vs-button",
            {
              staticClass: "p-3",
              attrs: { "icon-after": "", icon: "info" },
              on: {
                click: function($event) {
                  return _vm.$refs.observersInfo.show()
                }
              }
            },
            [_vm._v(" Explicación ")]
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "observersInfo",
          attrs: {
            title: "Observadores",
            size: "lg",
            centered: "",
            "no-close-on-backdrop": "",
            "hide-footer": ""
          }
        },
        [
          _c("p", [
            _vm._v(" Un observador es una persona que "),
            _c("b", [_vm._v("no es participante activo")]),
            _vm._v(
              " del flujo de aprobación, pero que puede acceder a consultar sobre ese documento y todo lo que se comente. Esto aplica también para un archivo que se agrega durante el ciclo de vida de la aprobación de un documento. "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }